import { Navigate, Outlet, useLocation } from "react-router-dom";

import constants from "@libs/acp/common/constants";
import { useAuthentication } from "@libs/acp/contexts/Authentication";
import { getCookie } from "@libs/utils/helpers/getSafeCookies";

import { pageNames } from "@shared/routes/pageNames";

export default function MFAPositiveDataRoutes() {
	const { isAuthenticated } = useAuthentication();

	const location = useLocation();
	const { state } = location;

	const cookiePassed = getCookie(constants.cookies.MFA_POSITIVE_DATA_PASSED);
	const statePassed = state?.unlockedPositiveData;
	const hasEnabledMFAPositiveData =
		isAuthenticated && (statePassed || cookiePassed);

	if (!hasEnabledMFAPositiveData) {
		return (
			<Navigate
				to={pageNames.mfaPositiveData.path}
				state={{ featureName: "CADASTRO POSITIVO", from: location.pathname }}
			/>
		);
	}

	return <Outlet />;
}
